import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export interface Selection {
  value: boolean;
  text: string;
}

@Component({
  selector: 'app-select-list',
  templateUrl: './select-list.component.html',
  styleUrls: ['./select-list.component.css']
})
export class SelectListComponent implements OnInit {
  @Input() Selections: Selection[] = [];
  @Input() name: string;
  @Output() changes: EventEmitter<string[]> = new EventEmitter();
  selectedList: string[] = [];
  inputTxt = '';

  constructor() { }

  ngOnInit() {

  }

  onChangeChk(event) {

    if (event.checked) {
      this.selectedList.push(event.source.id);
    } else {
      const index = this.selectedList.findIndex(n => n === event.source.id);
      this.selectedList.splice(index, 1);
    }
  }

  onClickAdd() {

    if (this.inputTxt.trim() === '') {
      return;
    }

    this.Selections.push({
      value: false,
      text: this.inputTxt
    });

    this.inputTxt = '';
    this.changes.emit(this.outputChanges());
  }

  onClickDelete() {

    if (this.selectedList.length === 0) {
      return;
    }

    this.Selections = this.Selections.filter(n => {
      return !this.selectedList.includes(n.text);
    });

    this.changes.emit(this.outputChanges());
  }

  outputChanges(): string[] {
    const txt = [];

    this.Selections.forEach(n => {
      txt.push(n.text);
    });

    return txt;
  }
}
